import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Router from '@/router'
import { AuthProvider } from '@/utility/context/auth'
import { ThemeProvider } from '@/utility/context/theme'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true },
  },
})

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <ToastContainer position="top-right" autoClose={5000} hideProgressBar closeOnClick />
      </AuthProvider>
    </ThemeProvider>
  </QueryClientProvider>
)

export default App
